import { combineReducers } from 'redux';
import { socketReducer } from './redux/reducers/socketReducer';
import authReducer from './redux/reducers/authenticationReducers';
import menuCategories from './views/menu/reducer';
import accountReducer from './views/myaccount/reducer';
import dashboard from './views/dashboard/reducer';
import { purgeStoredState } from 'redux-persist';
import checkout from './views/checkout/reducer';
import { asyncSessionStorage } from 'redux-persist/storages';
var _ = require('lodash');

const appReducer = combineReducers({
  rtd: socketReducer,
  auth: authReducer,
  menuCategories: menuCategories,
  myaccount: accountReducer,
  dashboard,
  checkout,
});

const initialState = appReducer({}, {});
const rootReducer = (state, action) => {
  if (action.type === 'UNAUTH_USER') {
    state = _.pick(state, ['menuCategories', 'dashboard']);
  } else if (
    action.type === 'RESET_DATA' ||
    action.type === 'CHANGE_DINING_OPTION'
  ) {
    let merchantDetails = state.dashboard.merchantDetails;
    state.dashboard = initialState.dashboard;
    state.dashboard.merchantDetails = merchantDetails;
    let intlState = _.pick(state, ['menuCategories', 'dashboard', 'auth']);
    state = intlState;
    purgeStoredState({ storage: asyncSessionStorage }, ['dashboard'])
      .then(() => {
        // console.log('purge of dashboard completed')
      })
      .catch(() => {
        // console.log('purge of dashboard failed')
      });
  }
  return appReducer(state, action);
};

export default rootReducer;



// WEBPACK FOOTER //
// ./src/rootReducer.jsx